import { useEffect, useRef } from "react";

// Calls `callback` every `intervalMs` while `active` is true, skipping
// ticks while the browser tab is hidden. Always calls the latest
// `callback`, so it sees the component's current state (filters, page).
export default function useIntervalWhile(callback, active, intervalMs) {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    if (!active) return undefined;
    const timer = setInterval(() => {
      if (document.visibilityState === "visible") callbackRef.current();
    }, intervalMs);
    return () => clearInterval(timer);
  }, [active, intervalMs]);
}
